module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_plus-eb390a1fe4fcecf5f21629bba2153903.svg";